import React from 'react';

import {
  Filter,
  Box,
  InputField,
  ListItem,
  DatepickerGroup,
  useWindowSize,
  Typography,
} from 'vindi-ds-components';

import { PrDownload, PrEdit2 } from 'vindi-ds-icons/pr';

const FilterQuickContainer = ({ onClickDownload, onClickMassEdit, quick }) => {
  const actions = [
    { label: 'Exportar', icon: <PrDownload />, onClick: onClickDownload },
    { label: 'Edição em massa', icon: <PrEdit2 />, onClick: onClickMassEdit },
  ];

  return (
    <Filter.QuickContainer actions={actions}>
      <Box width={{ sm: '100%', md: '288px' }}>
        <InputField name={quick.period.name} placeholder={quick.period.placeholder} select>
          {quick.period.options.map(({ key, value }) => (
            <ListItem key={key} value={value}>{key}</ListItem>
          ))}
        </InputField>
      </Box>
    </Filter.QuickContainer>
  );
};

const FilterPeriod = ({
  title,
  nameInitialDate,
  labelInitialDate,
  placeholderInitialDate,
  nameFinalDate,
  labelFinalDate,
  placeholderFinalDate,
}) => {
  const { isMobile } = useWindowSize();

  return (
    <Box width='100%'>
      <Box m={1 / 2}>
        {!isMobile && <Typography color='textPrimary'>{title}</Typography>}
      </Box>

      <Box
        display='grid'
        gridTemplateColumns={{ sm: '1fr', md: '1fr 1fr' }}
        gap={1}
      >
        <DatepickerGroup>
          <InputField
            name={nameInitialDate}
            label={labelInitialDate}
            placeholder={placeholderInitialDate}
            selectsStart
            datepicker
            hasRange
          />
          <InputField
            name={nameFinalDate}
            label={labelFinalDate}
            placeholder={placeholderFinalDate}
            selectsEnd
            datepicker
            hasRange
          />
        </DatepickerGroup>
      </Box>
    </Box>
  );
};

const FilterAdvancedFirstColumn = ({ className, advanced }) => {
  const { isMobile } = useWindowSize();

  const { start, end } = isMobile ? advanced.dates.mobile : advanced.dates.desktop;

  return (
    <Filter.Column className={className}>
      <Box display='grid' gridTemplateColumns='1fr' gap={{ xs: 2, md: 3 }}>
        <FilterPeriod {...start} />
        <FilterPeriod {...end} />

        <InputField
          name={advanced.status.name}
          label={advanced.status.label}
          placeholder={advanced.status.placeholder}
          select
        >
          {advanced.status.options.map(({ key, value }) => (
            <ListItem key={key} value={value}>{key}</ListItem>
          ))}
        </InputField>

        <InputField
          name={advanced.nonPayment.name}
          label={advanced.nonPayment.label}
          placeholder={advanced.nonPayment.placeholder}
          select
        >
          {advanced.nonPayment.options.map(({ key, value }) => (
            <ListItem key={key} value={value}>{key}</ListItem>
          ))}
        </InputField>
      </Box>
    </Filter.Column>
  );
};

const FilterAdvancedSecondColumn = ({ className, advanced, paymentMethods }) => (
  <Filter.Column className={className}>
    <Box mt={{ xs: 1, sm: 0 }}>
      <Box display='grid' gridTemplateColumns='1fr' gap={{ xs: 2, md: 3 }}>
        <InputField name={advanced.planId.name} label={advanced.planId.label} />
        <InputField name={advanced.customerId.name} label={advanced.customerId.label} />
        <InputField
          name={advanced.paymentMethod.name}
          label={advanced.paymentMethod.label}
          placeholder={advanced.paymentMethod.placeholder}
          select
          multiOpts
        >
          {paymentMethods.map(({ key, value }) => (
            <ListItem key={key} value={value}>{key}</ListItem>
          ))}
        </InputField>
      </Box>
    </Box>
  </Filter.Column>
);

const FilterAdvancedContainer = ({ filterFields, advanced, paymentMethods }) => (
  <Filter.AdvancedContainer>
    <FilterAdvancedFirstColumn
      filterFields={filterFields}
      advanced={advanced}
    />
    <FilterAdvancedSecondColumn
      filterFields={filterFields}
      advanced={advanced}
      paymentMethods={paymentMethods}
    />
  </Filter.AdvancedContainer>
);

const FiltersSubscriptions = ({ onClickDownload, onClickMassEdit, filterFields }) => {
  const { paymentMethods, filters: { quick, advanced } } = filterFields;

  return (
    <Box mt={3}>
      <FilterQuickContainer
        onClickDownload={onClickDownload}
        onClickMassEdit={onClickMassEdit}
        quick={quick}
      />

      <FilterAdvancedContainer
        filterFields={filterFields}
        advanced={advanced}
        paymentMethods={paymentMethods}
      />
    </Box>
  );
};

export default FiltersSubscriptions;
